import React, {
  createContext,
  useEffect,
  useState,
  useContext,
  useMemo,
} from 'react';
import { IconButton, Icon, SidebarPriorityItem } from '@monash/portal-react';
import { ImpersonationContext } from '../../components/impersonation-wrapper/ImpersonationWrapper';
import { getEnvironmentValue } from '../../utils/get-environment-value';
import { FeatureContext } from '../../feature-toggle/FeatureProvider';

export const ChatBotContext = createContext();

const ChatBotWrapper = ({ children }) => {
  const { currentUser } = useContext(ImpersonationContext);
  const { featureFlags } = useContext(FeatureContext);
  const [mounted, setMounted] = useState(false);

  const environmentVariable = {
    dev: 'https://monash-chat-server-dev.ts.r.appspot.com/api/v1/widget',
    qa: 'https://monash-chat-server-staging.appspot.com/api/v1/widget',
    prod: 'https://mbot.apps.monash.edu/api/v1/widget',
  };
  const chat365Bot = 'eb5d6a61-907f-4a13-b236-cf268e7a6129';

  // determine wether they can use chatbot, could be placed higher/lower
  const isAllowed = useMemo(
    () =>
      featureFlags.CHATBOT === true &&
      (currentUser?.is.Australian || currentUser?.is.Malaysian),
    [currentUser, featureFlags],
  );

  const mountProps = {
    cbid: chat365Bot,
    hiddenMessage: 'hello',
    hideButton: false,
  };

  const mountWidget = async () => {
    if (window.ChatBot) {
      try {
        window.ChatBot?.mount(mountProps);
        setMounted(true);
      } catch (e) {
        console.error(e);
      }
    }
  };

  const createScriptTag = () => {
    const fetchScript = document.createElement('script');
    fetchScript.src = getEnvironmentValue(environmentVariable);
    fetchScript.async = true;
    fetchScript.defer = true;
    fetchScript.onload = () => mountWidget();
    document.body.appendChild(fetchScript);
  };

  useEffect(() => {
    if (isAllowed) {
      createScriptTag();
    }
  }, [isAllowed]);

  const ChatBotButton = ({ isInSidebar = false, onClick, ...props }) => {
    if (isAllowed && mounted) {
      if (isInSidebar) {
        return (
          <SidebarPriorityItem
            icon={<Icon.ChatBot />}
            onClick={() => {
              window.toggleMcbChat();
              onClick?.();
            }}
            aria-label="Toggle Chatbot"
            {...props}
          >
            Chatbot
          </SidebarPriorityItem>
        );
      }
      return (
        <IconButton
          icon={Icon.ChatBot}
          size={24}
          onClick={() => {
            window.toggleMcbChat();
            onClick?.();
          }}
          aria-label="Toggle Chatbot"
          mode="canvas"
          {...props}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <ChatBotContext.Provider value={{ ChatBotButton }}>
      {children}
    </ChatBotContext.Provider>
  );
};

export default ChatBotWrapper;
